import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { apiCallBegan } from './api';
// import memoize from 'lodash.memoize'
// import values from "lodash.values";
import _ from 'lodash';
import { format, parseISO, parse } from 'date-fns';

import config from '../config/config';
import { addMeal } from './meal';

const apiToken = process.env.REACT_APP_API_TOKEN;

// Helpers methods
const getCouponIndex = (
  coupons,
  { mealId, date, meetingId, eventeatingId, eatingId }
) => {
  return coupons.findIndex(
    c =>
      c.date === date &&
      c.mealId === mealId &&
      c.meetingId === meetingId &&
      c.eventeatingId === eventeatingId &&
      c.eatingId === eatingId
  );
};

const getPersonType = name => {
  return config.personTypes.filter(p => p.label === name)[0].value;
};

const getTicketPrice = ticket => {
  // console.log('getTicketPrice', ticket.specialPrice);
  return ticket.specialPrice !== null
    ? parseInt(ticket.specialPrice)
    : ticket.coupons.reduce((acc, c) => acc + c.amount * c.price, 0);
};

export const getPrice = (customerType, meal) => {
  switch (parseInt(customerType)) {
    case 7:
      return meal.price;
    case 5:
      return meal.price;
    case 2:
      return meal.priceStaff;
    case 6:
      return meal.priceHelpers;
    case 3:
      return meal.priceKids5;
    case 4:
      return meal.priceKids12;
  }
};

const getCustomerTypeLabel = customerType => {
  switch (parseInt(customerType)) {
    case 5:
      return 'customer';
    case 2:
      return 'team';
    case 6:
      return 'special';
    case 3:
      return 'kids5';
    case 4:
      return 'kids12';
  }
};

const getMealById = (mealData, id) => {
  return mealData.filter(m => m.id === id)[0];
};

const addCheckedMeal = (res, meal, amount, checked) => {
  const mealName = `${meal.id} ${meal.name}`;
  if (mealName in res) {
    res[mealName]['total'] += amount;
    res[mealName]['checked'] += checked ? amount : 0;
    res[mealName]['remain'] += checked ? 0 : amount;
  } else {
    res[mealName] = {};
    res[mealName]['total'] = amount;
    res[mealName]['checked'] = checked ? amount : 0;
    res[mealName]['remain'] = checked ? 0 : amount;
  }
  return res;
};

const prepareDishSummary = (checkin, mealData) => {
  return checkin.reduce((res, ch) => {
    const { meal_id, couponeatingchecked, amount } = ch;
    const checked = couponeatingchecked.length > 0;

    const meal = getMealById(mealData, parseInt(meal_id));

    if (meal.isCombo === 1) {
      meal.comboMeals.forEach(m => {
        const childMeal = getMealById(mealData, m.meal_id);
        res = addCheckedMeal(res, childMeal, amount, checked);
      });
    } else {
      res = addCheckedMeal(res, meal, amount, checked);
    }

    return res;
  }, {});
};

const prepareSummary = users => {
  const summary = {};
  if (users && users.length > 0) {
    summary.all = {};
    summary.all.total = users.length;
    summary.all.checked = users.filter(u => u.checked === true).length;
    summary.all.remain = users.filter(u => u.checked === false).length;

    summary.team = {};
    summary.team.total = users.filter(u => u.customertype_id === 'team').length;
    summary.team.checked = users.filter(
      u => u.customertype_id === 'team' && u.checked === true
    ).length;
    summary.team.remain = users.filter(
      u => u.customertype_id === 'team' && u.checked === false
    ).length;

    summary.customers = {};
    summary.customers.total = users.filter(
      u => u.customertype_id !== 'team' && u.customertype_id !== 'special'
    ).length;
    summary.customers.checked = users.filter(
      u =>
        u.customertype_id !== 'team' &&
        u.customertype_id !== 'special' &&
        u.checked === true
    ).length;
    summary.customers.remain = users.filter(
      u =>
        u.customertype_id !== 'team' &&
        u.customertype_id !== 'special' &&
        u.checked === false
    ).length;

    summary.special = {};
    summary.special.total = users.filter(
      u => u.customertype_id == 'special'
    ).length;
    summary.special.checked = users.filter(
      u => u.customertype_id == 'special' && u.checked === true
    ).length;
    summary.special.remain = users.filter(
      u => u.customertype_id == 'special' && u.checked === false
    ).length;

    return summary;
  }

  summary.all = {};
  summary.all.total = 0;
  summary.all.checked = 0;
  summary.all.remain = 0;

  summary.team = {};
  summary.team.total = 0;
  summary.team.checked = 0;
  summary.team.remain = 0;

  summary.customers = {};
  summary.customers.total = 0;
  summary.customers.checked = 0;
  summary.customers.remain = 0;

  summary.special = {};
  summary.special.total = 0;
  summary.special.checked = 0;
  summary.special.remain = 0;

  return summary;
};

const getMealId = id => {
  return config.defaultMealMapping[id] ? config.defaultMealMapping[id] : id;
};

// slice

const initialState = {
  coupons: [],
  customerType: getPersonType('Участник'),
  price: 0,
  pricePaid: 0,
  specialPrice: null,
  mealReport: {},
  checkin: {}
};

const slice = createSlice({
  name: 'ticket',
  initialState,
  reducers: {
    couponAdded: (ticket, action) => {
      const {
        mealId,
        date,
        meetingId,
        eventeatingId,
        eatingId,
        price
      } = action.payload;
      const index = getCouponIndex(ticket.coupons, action.payload);
      if (index !== -1) {
        ++ticket.coupons[index].amount;
      } else {
        ticket.coupons.push({
          mealId,
          date,
          meetingId,
          eventeatingId,
          eatingId,
          price,
          amount: 1
        });
      }
      // ticket.price = ticket.coupons.reduce((acc, c) => acc + c.amount * c.price, 0)
      // ticket.price = getTicketPrice(ticket.coupons, ticket.specialPrice)
      // const test = getTicketPrice(ticket)
      // console.log('test', test, ticket);
      ticket.price = getTicketPrice(ticket);
    },

    deleteCoupon: (ticket, action) => {
      const index = getCouponIndex(ticket.coupons, action.payload);
      if (index !== -1) {
        if (ticket.coupons[index].amount > 1) {
          --ticket.coupons[index].amount;
        } else {
          ticket.coupons[index].amount = 0;
        }
      }
      ticket.price = getTicketPrice(ticket);
      // ticket.price = getTicketPrice(ticket.coupons, ticket.specialPrice)
    },

    couponsSet: (ticket, action) => {
      const { coupons, specialPrice, customerId } = action.payload;
      // console.log('couponsSet', coupons, specialPrice, customerId);
      ticket.coupons = coupons;
      ticket['specialPrice'] = specialPrice;
      // console.log('ticket', ticket.specialPrice);
      ticket.pricePaid = getTicketPrice(ticket);
      // Убераем спесиша прайс что бы посчитать сколько на самом деле стоит билет
      // ticket['specialPrice'] = null
      ticket.price = getTicketPrice(ticket);
      ticket.customerId = customerId;
      // ticket.price = getTicketPrice(ticket)
      // ticket.price = getTicketPrice(ticket.coupons, ticket.specialPrice)

      // ticket.price = getTicketPrice(ticket.coupons, ticket.specialPrice)
    },

    customerTypeSet: (ticket, action) => {
      ticket['customerType'] = action.payload.customerType;
      ticket.coupons = action.payload.coupons;
      // ticket.price = ticket.coupons.reduce((acc, c) => acc + c.amount * c.price, 0)
      // console.log('customerTypeSet ticket', ticket);
      // ticket.price = getTicketPrice(ticket)
      // console.log('customerTypeSet price', getTicketPrice(ticket));
      // ticket.price = getTicketPrice(ticket.coupons, ticket.specialPrice)
    },

    setTicketSpecialPrice: (ticket, action) => {
      ticket['specialPrice'] = action.payload.specialPrice;
      ticket.price = getTicketPrice(ticket);
      // ticket.price = getTicketPrice(ticket.coupons, ticket.specialPrice)
    },

    ticketManualPriceSet: (ticket, action) => {
      const { price } = action.payload.params;
      ticket['specialPrice'] = price;
      ticket.price = getTicketPrice(ticket);
    },

    setTicketPricePaid: (ticket, action) => {
      // console.log('setTicketPricePaid action.payload.pricePaid', action.payload.pricePaid);
      ticket['pricePaid'] = action.payload.pricePaid;
      // ticket.price = getTicketPrice(ticket.coupons, ticket.specialPrice)
    },

    resetTicket: (ticket, action) => {
      ticket.coupons = [];
      ticket.customerType = getPersonType('Участник');
      ticket.price = 0;
      ticket.specialPrice = null;
    },

    ticketLoaded: (ticket, action) => {
      // console.log('action.payload', action.payload);
      // ticket.price = getTicketPrice(ticket)
    },

    couponChanged: (ticket, action) => {
      // console.log('action.payload', action.payload);
      // ticket.price = getTicketPrice(ticket)
    },

    // ticketLoaded: (ticket, action) => {
    //   // console.log('action.payload', action.payload);
    //   // ticket.price = getTicketPrice(ticket)

    // },

    // couponChanged
    couponsByDateLoaded: (ticket, action) => {
      ticket.checkin = action.payload.data;
    },

    mealCouponsChecked: (ticket, action) => {
      const { userId, mealId } = action.payload.params;
      const userIndex = ticket.checkin.users.findIndex(
        u => parseInt(u.user_id) === parseInt(userId)
      );
      const mealIndex = ticket.checkin.users[userIndex]['meals'].findIndex(
        m => m.mealId === mealId
      );
      ticket.checkin.users[userIndex]['meals'][mealIndex] = {
        ...ticket.checkin.users[userIndex]['meals'][mealIndex],
        checked: !ticket.checkin.users[userIndex]['meals'][mealIndex].checked
      };
    },

    couponsChecked: (ticket, action) => {
      const { userId, eatingId } = action.payload.params;
      const mealData = action.payload.params.meals;

      let checkin = [];
      let checked = false;

      ticket.checkin.users.forEach(u => {
        if (u.user_id === userId) {
          checked = !u.checked;
          checkin.push({ ...u, checked: !u.checked });
        } else {
          checkin.push(u);
        }
      });

      // Найдем индексы копонов плоьзователя, чтобы изменить их признак чекина
      const indexes = ticket.checkin.checkin.reduce(function(res, ch, i) {
        // console.log('ch', ch.Customer.id, userId);
        if (ch.Customer.id === parseInt(userId)) res.push(i);
        return res;
      }, []);
      // console.log('indexes', indexes);
      // console.log('checked', checked);
      // console.log('ticket.checkin.checkin', ticket.checkin.checkin[indexes[0]]);

      // Установим признак чекина в списке для всех купонов юзера
      indexes.forEach(index => {
        if (checked) {
          if (ticket.checkin.checkin[index].couponeatingchecked.length === 0) {
            ticket.checkin.checkin[index] = {
              ...ticket.checkin.checkin[index],
              couponeatingchecked: [{ id: null }]
            };
          }
        } else {
          ticket.checkin.checkin[index] = {
            ...ticket.checkin.checkin[index],
            couponeatingchecked: []
          };
        }
      });

      ticket.checkin.users = checkin;
      ticket.checkin.summary = prepareSummary(checkin);
      ticket.checkin.dishSummary = prepareDishSummary(
        ticket.checkin.checkin,
        mealData
      );
    },

    checkinLoaded: (ticket, action) => {
      const checkin = action.payload.data;
      const mealData = action.payload.params.meals;

      if (checkin.length > 0) {
        // Оставим только нужные поля
        const preparedUsers = checkin.map(c => {
          return {
            user_id: c.Customer.id,
            user_name: `${c.Customer.surname} ${c.Customer.name}`,
            customertype_id: c.customertype_id,
            eating_id: c.Eventeating.eating_id,
            meal_id: c.meal_id,
            amount: c.amount,
            checked: !(c.couponeatingchecked.length < c.amount)
          };
        });

        // Сделаем группировку
        const res = _(preparedUsers)
          .groupBy('user_id')
          .reduce(function(res, user, id) {
            const u = {};
            u['user_id'] = id;
            u['user_name'] = user[0].user_name;
            u['customertype_id'] = getCustomerTypeLabel(
              user[0].customertype_id
            );
            u['checked'] = user.every(u => u.checked);
            u['meals'] = user.map(u => {
              return {
                mealId: u.meal_id,
                checked: u.checked,
                amount: u.amount,
                mealName: mealData.filter(m => m.id === u.meal_id)[0].name
              };
            });

            res.push(u);
            return res;
          }, []);

        ticket.checkin.users = res;
        ticket.checkin.summary = prepareSummary(res);
        ticket.checkin.checkin = checkin;
        ticket.checkin.dishSummary = prepareDishSummary(checkin, mealData);
      } else {
        ticket.checkin.summary = prepareSummary([]);
        ticket.checkin.dishSummary = prepareDishSummary([], mealData);
      }
    },

    ticketsByDateLoaded: (ticket, action) => {
      const coupons = action.payload.data;
      const sumResult = coupons.reduce((res, coupon) => {
        const { eating_id, meal_id, customertype_id, amount } = coupon;
        // console.log('coupon', coupon);
        if (!(eating_id in res)) {
          res[eating_id] = {};
        }

        if (meal_id in res[eating_id]) {
          res[eating_id][meal_id]['total'] += amount;
          res[eating_id][meal_id][customertype_id] =
            customertype_id in res[eating_id][meal_id]
              ? res[eating_id][meal_id][customertype_id] + amount
              : amount;
        } else {
          res[eating_id][meal_id] = {};
          res[eating_id][meal_id]['total'] = amount;
          res[eating_id][meal_id][customertype_id] = amount;
        }
        return res;
      }, {});
      ticket.mealReport[action.payload.params.date] = {};
      ticket.mealReport[action.payload.params.date].list = coupons;
      ticket.mealReport[action.payload.params.date].grouped = sumResult;
    }
  }
});

export const {
  couponAdded,
  deleteCoupon,
  customerTypeSet,
  setTicketSpecialPrice,
  resetTicket,
  ticketLoaded,
  couponsSet,
  ticketsByDateLoaded,
  couponsByDateLoaded,
  checkinLoaded,
  couponsChecked,
  couponChanged,
  setTicketPricePaid,
  ticketManualPriceSet,
  mealCouponsChecked
} = slice.actions;
export default slice.reducer;

// Action Creators

export const addCoupon = ({
  mealId,
  date,
  meetingId,
  eventeatingId,
  eatingId
}) => async (dispatch, getState) => {
  const meal = getState().entities.meal.list.filter(m => m.id === mealId)[0];
  const customerType = getState().entities.ticket.customerType;
  const price = getPrice(customerType, meal);
  // console.log('addCoupon price', price);
  dispatch({
    type: couponAdded.type,
    payload: { mealId, date, meetingId, eventeatingId, eatingId, price }
  });
};

export const setCoupons = (coupons, specialPrice) => async (
  dispatch,
  getState
) => {
  const meals = getState().entities.meal.list;
  const customerType = getState().entities.ticket.customerType;

  // console.log('setCoupons customerType',customerType, specialPrice);
  // return
  const couponsPrepared = [];
  coupons.forEach(coupon => {
    const meal = meals.filter(m => m.id === getMealId(coupon.Meal.id))[0];
    // console.log('meal', coupon.customertype_id, meal);
    const price = getPrice(coupon.customertype_id, meal);
    // console.log('price',price);
    couponsPrepared.push({
      mealId: getMealId(coupon.Meal.id),
      date: format(parseISO(coupon.Eventeating.date), 'dd.MM.yyyy'),
      meetingId: coupon.Eventeating.meeting_id,
      eventeatingId: coupon.Eventeating.id,
      amount: coupon.amount,
      eatingId: coupon.Eventeating.eating_id,
      price
    });
  });

  await dispatch({
    type: couponsSet.type,
    payload: {
      coupons: couponsPrepared,
      specialPrice,
      customerId: parseInt(coupons[0].Customer.id)
    }
    // {mealId, date, meetingId, eventeatingId, eatingId, price}
  });
};

export const setCustomerType = ({ customerType }) => async (
  dispatch,
  getState
) => {
  const coupons = getState().entities.ticket.coupons;
  const meals = getState().entities.meal.list;
  let newcoupons = [];
  coupons.forEach(coupon => {
    const meal = meals.filter(m => m.id === coupon.mealId)[0];
    const price = getPrice(customerType, meal);
    // console.log('setCustomerType price',price);
    newcoupons.push({ ...coupon, price });
  });
  await dispatch({
    type: customerTypeSet.type,
    payload: { coupons: newcoupons, customerType }
  });
};

export const changeCustomer = (ticketId, customerId, customerType) => async (
  dispatch,
  getState
) => {
  const data = await dispatch(
    apiCallBegan({
      url: `/api/ticket/change_customer/${ticketId}/${customerId}/${customerType}?secret_key=${apiToken}`,
      // onSuccess: ticketLoaded.type,
      actionName: 'changeCustomer',
      params: { ticketId, customerId }
    })
  );
  if (data) {
    if (data.type === 'api/callFailed') return data;
  }
};

export const loadTicket = ticketId => async (dispatch, getState) => {
  return await dispatch(
    apiCallBegan({
      url: `/api/ticket/get_eating/${ticketId}?secret_key=${apiToken}`,
      onSuccess: ticketLoaded.type,
      actionName: 'loadTicket',
      params: { ticketId }
    })
  );
};

export const loadTicketsByDate = date => async (dispatch, getState) => {
  const eventId = config.eventId;
  const dateFormated = format(
    parse(date, 'dd.MM.yyyy', new Date()),
    'ddMMyyyy'
  );

  // console.log('getState()',getState());

  const meals = getState().entities.meal.list;
  // console.log('meals',meals.filter(m => m.isCombo === 1).map(m => m.comboMeals));

  const data = await dispatch(
    apiCallBegan({
      url: `/api/ticket/get_eating_by_date/${eventId}/${dateFormated}?secret_key=${apiToken}`,
      // onSuccess: ticketsByDateLoaded.type,
      actionName: 'loadTicketsByDate',
      params: { date }
    })
  );
  if (data) {
    if (data.type === 'api/callFailed') return data;

    // console.log('data',data );
    // console.log('meals',meals);
    let newCoupons = [];
    data.forEach(c => {
      // console.log('coupon',c);
      const meal = meals.filter(m => m.id === getMealId(c.meal_id))[0];
      // console.log('meal',c.meal_id , getMealId(c.meal_id), meal);
      if (meal.isCombo === 1) {
        meal.comboMeals.forEach(combo => {
          // console.log('combo.meal_id', combo.meal_id);
          const cu = _.cloneDeep(c);
          cu['isCombo'] = true;
          cu['parentId'] = meal.id;
          cu['parentName'] = meal.name;
          cu['meal_id'] = combo.meal_id;
          cu['mealName'] = null;
          newCoupons.push(cu);
        });
      } else {
        newCoupons.push({
          ...c,
          meal_id: getMealId(c.meal_id),
          isCombo: false,
          parentId: null,
          mealName: meal.name,
          parentName: null
        });
      }
    });

    // console.log('newCoupons', newCoupons);

    await dispatch({
      type: ticketsByDateLoaded.type,
      payload: { data: newCoupons, params: { date } }
    });
  }
};

export const loadCheckin = (date, eatingId) => async (dispatch, getState) => {
  const selectedDateFormated = format(date, 'ddMMyyyy');
  const meals = getState().entities.meal.list;

  return await dispatch(
    apiCallBegan({
      url: `/api/ticket/checkin_users/${selectedDateFormated}/${eatingId}?secret_key=${apiToken}`,
      onSuccess: checkinLoaded.type,
      actionName: 'loadCheckin',
      params: { eatingId, meals }
    })
  );
};

export const setTicketManualPrice = (ticketId, price) => async dispatch => {
  return await dispatch(
    apiCallBegan({
      url: `/api/ticket/${ticketId}/manual_price?secret_key=${apiToken}`,
      method: 'patch',
      onSuccess: ticketManualPriceSet.type,
      data: { price },
      actionName: 'setTicketManualPrice',
      params: { ticketId, price }
    })
  );
};

export const checkCouponsByUserAndEating = (userId, date, eatingId) => async (
  dispatch,
  getState
) => {
  const selectedDateFormated = format(date, 'ddMMyyyy');
  const meals = getState().entities.meal.list;

  return await dispatch(
    apiCallBegan({
      url: `/api/ticket/checkedcoupon/checkin/${userId}/${eatingId}/${selectedDateFormated}?secret_key=${apiToken}`,
      onSuccess: couponsChecked.type,
      actionName: 'checkCouponsByUserAndEating',
      params: { userId, date: selectedDateFormated, meals: meals, eatingId }
    })
  );
};

// For bar check only one meal
export const checkCouponsByUserAndMeal = (userId, date, mealId) => async (
  dispatch,
  getState
) => {
  const selectedDateFormated = format(date, 'ddMMyyyy');
  return await dispatch(
    apiCallBegan({
      url: `/api/coupons/check_in/${userId}/${mealId}/${selectedDateFormated}?secret_key=${apiToken}`,
      method: 'POST',
      onSuccess: mealCouponsChecked.type,
      actionName: 'checkCouponsByUserAndMeal',
      params: { userId, date: selectedDateFormated, mealId }
    })
  );
};

export const deleteCouponsByUserAndMeal = (userId, date, mealId) => async (
  dispatch,
  getState
) => {
  const selectedDateFormated = format(date, 'ddMMyyyy');
  return await dispatch(
    apiCallBegan({
      url: `/api/coupons/check_in/${userId}/${mealId}/${selectedDateFormated}?secret_key=${apiToken}`,
      method: 'DELETE',
      onSuccess: mealCouponsChecked.type,
      actionName: 'deleteCouponsByUserAndMeal',
      params: { userId, date: selectedDateFormated, mealId }
    })
  );
};

export const deleteCouponsByUserAndEating = (userId, date, eatingId) => async (
  dispatch,
  getState
) => {
  const selectedDateFormated = format(date, 'ddMMyyyy');
  const meals = getState().entities.meal.list;

  return await dispatch(
    apiCallBegan({
      url: `/api/ticket/checkedcoupon/delete/${userId}/${eatingId}/${selectedDateFormated}?secret_key=${apiToken}`,
      onSuccess: couponsChecked.type,
      actionName: 'checkCouponsByUserAndEating',
      params: { userId, date: selectedDateFormated, meals: meals, eatingId }
    })
  );
};

export const changeCoupon = ({
  action,
  mealId,
  date,
  meetingId,
  ticketId,
  customerType,
  customerId
}) => async (dispatch, getState) => {
  const couponDate = date.split('.').join('');

  return await dispatch(
    apiCallBegan({
      url: `/api/ticket/change_cuponeating/${ticketId}/${mealId}/${meetingId}/${couponDate}/${customerId}/${customerType}/${action}?secret_key=${apiToken}`,
      onSuccess: couponChanged.type,
      actionName: 'changeCoupon',
      params: { action, mealId, date, meetingId }
    })
  );
};

// Selectors
// getTicketCouponsSelector

export const getTicketCouponsPriceSelector = createSelector(
  state => state.entities.ticket.coupons,
  coupons =>
    coupons.reduce((acc, d) => {
      return acc + d.price * d.amount;
    }, 0)
);

export const getTicketCouponsSelector = createSelector(
  state => state.entities.ticket.coupons,
  coupons => coupons
);

export const getTicketCustomerTypeSelector = createSelector(
  state => state.entities.ticket.customerType,
  customerType => customerType
);

export const getTicketCustomerIdSelector = createSelector(
  state => state.entities.ticket.customerId,
  customerId => customerId
);

export const getTicketPriceSelector = createSelector(
  state => state.entities.ticket.price,
  price => price
);

export const getTicketPricePaidSelector = createSelector(
  state => state.entities.ticket.pricePaid,
  price => price
);

export const getTicketCouponsByEatingSelector = (meetingId, date, eatingId) =>
  createSelector(
    state => state.entities.ticket.coupons,
    coupons => {
      return coupons.length > 0
        ? coupons.filter(
            c =>
              c.date === date &&
              c.meetingId === meetingId &&
              c.eatingId === eatingId
          )
        : [];
    }
    // coupons => coupons
  );

export const getTicketMealReportByDateSelector = (date, eatingId) =>
  createSelector(
    state => state.entities.ticket.mealReport,
    mealReport =>
      mealReport && mealReport[date] && mealReport[date].grouped[eatingId]
        ? mealReport[date].grouped[eatingId]
        : ''
  );

export const getTicketCheckinUsers = createSelector(
  state => state.entities.ticket.checkin,
  // mealReport => mealReport && mealReport[date] && mealReport[date][eatingId]
  checkin => checkin.users
);

export const getTicketCheckinSummary = createSelector(
  state => state.entities.ticket.checkin,
  // mealReport => mealReport && mealReport[date] && mealReport[date][eatingId]
  checkin => checkin.summary
);

export const getDishCheckInSummary = createSelector(
  state => state.entities.ticket.checkin.dishSummary,
  // mealReport => mealReport && mealReport[date] && mealReport[date][eatingId]
  dishSummary => dishSummary
);

export const getTicketMealReportCouponsByDateSelector = date =>
  createSelector(
    state => state.entities.ticket.mealReport,
    // mealReport => mealReport && mealReport[date] && mealReport[date][eatingId]
    mealReport => mealReport && mealReport[date] && mealReport[date].list
  );
